export default __webpack_public_path__ + "static/media/list_02_img.037a25b3.png";